
import { defineComponent, reactive, ref } from "vue";
import { Menu } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import moment from "moment";
import { ElMessageBox, ElMessage } from "element-plus";
import type { FormInstance, FormRules, PopoverInstance } from "element-plus";
import KTModalMenu from "@/components/modals/forms/MenuModal.vue";
import { componentSize } from "@/utils/userMenuUtil";
import { CookieComponent } from "@/assets/ts/components";

interface DataForm {
  level: number | null;
  nMaChucNang: number | null;
  parentName: string | null;
  cTenChucNang: string | null;
  nMaChucNangCha: string | null;
  cUrl: string | null;
  cQuyen: string | null;
  nLoai: number | null;
  cIcon: string | null;
  nThuTu: string | null;
  delFlag: string | null;
  cNguoiTao: string | null;
  dNgayTao: string | null;
  cNguoiCapNhatCuoi: string | null;
  dNgayCapNhatCuoi: string | null;
  nTinhTrang: number | null;
  nSystem: number | null;
}

interface Selected {
  level: number | null;
  nMaChucNang: number | null;
  parentName: string | null;
  cTenChucNang: string | null;
  nMaChucNangCha: string | null;
  cUrl: string | null;
  cQuyen: string | null;
  nLoai: number | null;
  cIcon: string | null;
  nThuTu: string | null;
  delFlag: string | null;
  cNguoiTao: string | null;
  dNgayTao: string | null;
  cNguoiCapNhatCuoi: string | null;
  dNgayCapNhatCuoi: string | null;
  nTinhTrang: number | null;
  nSystem: number | null;
  children: Selected[];
}

export default defineComponent({
  name: "menus",

  components: { KTModalMenu },

  setup() {
    
    const perms = ref(CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions") as string) : []);
    const popover = ref<PopoverInstance>();
    const store = ref(useStore());
    const router = ref(useRouter());
    const loading = ref<boolean>(false);
    const openDialog = ref<boolean>(false);
    const tableData = ref<Array<Selected>>([]);
    const menuList = ref<Array<Selected>>([]);

    const dataForm = reactive<DataForm>({
      level: null,
      nMaChucNang: null,
      parentName: null,
      cTenChucNang: null,
      nMaChucNangCha: null,
      cUrl: null,
      cQuyen: null,
      nLoai: null,
      cIcon: null,
      nThuTu: null,
      delFlag: null,
      cNguoiTao: null,
      dNgayTao: null,
      cNguoiCapNhatCuoi: null,
      dNgayCapNhatCuoi: null,
      nTinhTrang: null,
      nSystem: null,
    });

    const dialog = reactive({
      title: "",
      type: 0 as number,
      action: 0,
      /* 0-add 1-edit 2-password 3-info*/
      closing: "",
      rules: {} as FormRules<DataForm>,
    });

    const rules = reactive<FormRules<DataForm>>({
      cTenChucNang: [
        {
          required: true,
          message: "Xin vui lòng nhập tên chức năng",
          trigger: "blur",
        },
      ],
      cUrl: [
        { required: true, message: "Xin vui lòng nhập url", trigger: "blur" },
      ],
      nLoai: [
        {
          required: true,
          message: "Xin vui lòng chọn loại chức năng",
          trigger: "blur",
        },
      ],
      nThuTu: [
        {
          required: true,
          message: "Xin vui lòng nhập thứ tự",
          trigger: "blur",
        },
      ],
    });

    const clearForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
    };

    const selected = ref<Selected>({
      level: null,
      nMaChucNang: null,
      parentName: null,
      cTenChucNang: null,
      nMaChucNangCha: null,
      cUrl: null,
      cQuyen: null,
      nLoai: null,
      cIcon: null,
      nThuTu: null,
      delFlag: null,
      cNguoiTao: null,
      dNgayTao: null,
      cNguoiCapNhatCuoi: null,
      dNgayCapNhatCuoi: null,
      nTinhTrang: null,
      nSystem: null,
      children: []
    });

    const treeProp = ref({
      level: "level",
      nMaChucNang: "nMaChucNang",
      parentName: "parentName",
      cTenChucNang: "cTenChucNang",
      nMaChucNangCha: "nMaChucNangCha",
      cUrl: "cUrl",
      cQuyen: "cQuyen",
      nLoai: "nLoai",
      cIcon: "cIcon",
      nThuTu: "nThuTu",
      delFlag: "delFlag",
      cNguoiTao: "cNguoiTao",
      dNgayTao: "dNgayTao",
      cNguoiCapNhatCuoi: "cNguoiCapNhatCuoi",
      dNgayCapNhatCuoi: "dNgayCapNhatCuoi",
      nTinhTrang: "nTinhTrang",
      nSystem: "nSystem",
      children: [],
    });

    const defaultValues = reactive<DataForm>({
      level: null,
      nMaChucNang: null,
      parentName: null,
      cTenChucNang: null,
      nMaChucNangCha: null,
      cUrl: null,
      cQuyen: null,
      nLoai: null,
      cIcon: null,
      nThuTu: null,
      delFlag: null,
      cNguoiTao: null,
      dNgayTao: null,
      cNguoiCapNhatCuoi: null,
      dNgayCapNhatCuoi: null,
      nTinhTrang: null,
      nSystem: null,
    });
    const size = ref<string>("");

    return {
      perms,
      router,
      popover,
      treeProp,
      dialog,
      openDialog,
      tableData,
      menuList,
      dataForm,
      defaultValues,
      store,
      loading,
      rules,
      selected,
      size,
      clearForm,
    };
  },
  methods: {
    handleDate(date: string) {
      return moment(date).format("DD/MM/YYYY");
    },

    handleFindPage() {
      this.loading = true;
      let userName = CookieComponent.get("userName")
      let pageRequest = {
        columnFilters: {
          cTenChucNang: { value: "" },
          nLoai: { value: "1" },
          currentSystem: { value: CookieComponent.get("system") }
        },
        pageNum: 1,
        pageSize: 50,
      };
      this.store.dispatch(Menu.findMenu, pageRequest).then((res) => {
        if (res.code == 200) {
          this.menuList = res.data;
          this.tableData = res.data;
          this.loading = false;
        } else {
          ElMessage({
            message: "Có lỗi xảy ra",
            type: "error",
          });
        }
      }).catch(error => {
        ElMessage({ message: "Tìm kiếm chức năng thất bại!", type: "error" });
      });;
    },

    handleFindMenuTree() {
      let userName = CookieComponent.get("userName")
      this.store.dispatch(Menu.findMenuTree, { 'userName': userName, 'system': 3 }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.loading = false;
        } else {
          ElMessage({
            message: "Có lỗi xảy ra",
            type: "error",
          });
        }
      }).catch(error => {
        ElMessage({ message: "Tìm kiếm chức năng thất bại!", type: "error" });
      });;
    },

    async handleOpenAdd() {
      this.dialog.title = "Thêm chức năng";
      this.dialog.type = 1;
      this.dialog.action = 0;
      for (let prop in this.dataForm) {
        this.dataForm[prop] = null;
      }
      for (let prop in this.defaultValues) {
        this.defaultValues[prop] = null;
      }
    },

    //open update
    async handleOpenUpdate(val) {
      this.dialog.title = "Chỉnh sửa chức năng";
      this.dialog.type = val.type;
      this.dialog.action = 1;
      for (let prop in val) {
        if (prop in this.dataForm) this.dataForm[prop] = val[prop];
      }
      for (let prop in val) {
        if (prop in this.defaultValues) this.defaultValues[prop] = val[prop];
      }
    },

    handleDelete(val) {
      let params = { nMaChucNang: val.nMaChucNang };
      ElMessageBox.confirm("Bạn có chắc muốn xóa chức năng này?")
        .then(() => {
          this.store.dispatch(Menu.deleteMenu, [params]).then((res) => {
            if (res.code == 200) {
              ElMessage({
                message: `Xóa chức năng thành công`,
                type: "success",
              });

              this.handleFindPage();
            } else {
              ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
            }
          }).catch(error => {
            ElMessage({ message: "Xóa chức năng thất bại!", type: "error" });
          });;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCheckPerms(val){
      return this.perms.includes(val)
    }
  },
  mounted() {
    this.size = componentSize();
    onresize = () => {
      this.size = componentSize();
    };
    this.dialog.rules = this.rules;
    this.handleFindPage();
  },
});
